import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Modal, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { ConfirmaEliminar, EliminarTipoActivo, GuardarNuevoTipoActivo, ValidaAsuntosInstalacion } from '../../helpers/ActivosHelper';
import { ActivosContext } from '../../pages/catalogos/ActivosPage';
import { TiposActivoContext } from '../../pages/catalogos/ActivosTipoPage';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
export const ModalEliminaInstalacionComponent = ({modalEliminaInstalacion, setModalEliminaInstalacion, datosInstalacion}) => {
    const {obtenerActivos} = useContext(ActivosContext);
    const [errorGuardado, setErrorGuardado] = useState(false);
    const [habilitaEliminar, setHabilitaEliminar] = useState(false)
    const [asuntosRelacionados, setAsuntosRelacionados] = useState(0);
    const refForm = useRef()
    ;
    console.log('datos de instalacion recibida para eliminar', datosInstalacion);

    const handleClose = () => {
        setModalEliminaInstalacion(false);
    }

    const handleSubmit =  (event) => {
        event.preventDefault();
        //refForm.current.isValidate();
    }

    const validaAsuntosInstalacion = () => {
      ValidaAsuntosInstalacion(datosInstalacion).then(data => {
          console.log('asuntos relacionados al nodo a eliminar', data);
          setAsuntosRelacionados(data);
          if(parseInt(data)>0) {
            setHabilitaEliminar(false);
          } else {
            setHabilitaEliminar(true);
          }
      })
    }

    const confirmaEliminar = () => {
      ConfirmaEliminar(datosInstalacion).then(data => {
        obtenerActivos();
        handleClose();
      })
    }

    useEffect(() => {
      validaAsuntosInstalacion();
    }, [datosInstalacion])
    

  return (
      <div
        style={{
            minWidth:600
        }}
    >
     <Dialog open={modalEliminaInstalacion} onClose={handleClose}>
        <form onSubmit={handleSubmit} ref={refForm}>
        <DialogTitle>¿Eliminar la instalación?</DialogTitle>
        <DialogContent
            style={{minWidth:600}}
        >
          Se eliminará la instalación seleccionada y todas las instalaciones de niveles inferiores
          {
            errorGuardado && (
              <Typography
                style={{
                    fontSize:12,
                    color:'red'
                }}
              >
                Error al guardar
            </Typography>
            )
          }
          {
            parseInt(asuntosRelacionados)>0 && (
              <Typography
                style={{
                    fontSize:12,
                    color:'red'
                }}
              >
                Hay {asuntosRelacionados} asuntos que pertenecen a la(s) instalaciones seleccionadas, no se puede eliminar una instalación que tiene asuntos relacionados
            </Typography>
            )
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button 
            onClick={() => confirmaEliminar()}
            disabled={!habilitaEliminar}
            type='submit' >Eliminar</Button>
        </DialogActions>
        </form>
      </Dialog>
    </div>
  )
}
